import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import RelatedPerson from '../components/relatedPerson';
import ProfileHeader from '../components/ProfileHeader';
import { useDispatch, useSelector } from 'react-redux';
import { API_URL } from '../config';
import {
    setUsersPayer,
    setUsersParticipant,
    setCurseHadings,
    setStartDate,
} from '../reducers/reposReducers';
import ApiService from '../services/ApiService';
import NotificationService from '../services/NotificationService';
import EDSFooter from '../components/EDSFooter';
import * as globals from '../globals.js';

var participantActive = '';
var participantBuilding = '';
var participantCity = '';
var participantDateOfBirdth = '';
var participantEmail = '';
var participantFirstName = '';
var participantFlat = '';
var participantGenderDVID = '';
var participantLastName = '';
var participantLogin = '';
var participantPersonalDataProcessingConsent = '';
var participantPesel = '';
var participantPhone = '';
var participantPostalCode = '';
var participantStreet = '';
var participantUsersID = '';

const Wybor_opcji_1_uczestnik = () => {
    const key = useSelector((state) => state.repos.chName);
    if (!key || key == '') {
        history.push(`/LoginBuy/key=${localStorage.getItem('keyURL')}`);
      
    }
    const today = new Date(new Date());
    const date = today.setDate(today.getDate());
    const defaultValue = new Date(date).toISOString().split('T')[0]; // yyyy-mm-dd
    const [formData, setFromData] = useState({
        startDate: defaultValue,
    });
    const dispatch = useDispatch();
    const usersPayerDispatch = useDispatch();
    const usersParticipantDispatch = useDispatch();
    const apiService = ApiService.getInstance();
    const notificationService = NotificationService.getInstance();

    localStorage.setItem('users', JSON.stringify(''));

    let payerUserdata = useSelector((state) => state.repos.users);
    let usersParticipant = useSelector((state) => state.repos.usersParticipant);
    let defaultStateUsers = false;
    const [allert, setallert] = useState(false);

    const dataSelecrCurse = useDispatch();
    const history = useHistory();
    const getSubaccountsURL = `${API_URL}GetSubaccounts`;

    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const [selectedItem, setSelectedItem] = useState(0);
    const [res, setRes] = useState([]);
    const [getResponse, setGetResponse] = useState(0);
    const [formDataHeading] = useState({
        courseHeadingName: useSelector((state) => state.repos.chName), // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        attendanceStartDate: `${defaultValue}`,
        current_LocalizationsID: '0',
    });

    if (payerUserdata && payerUserdata.usersID) {
        defaultStateUsers = true;
        // setSelectedItem(1)
    } else if (!usersParticipant) {
        defaultStateUsers = true;
    } 


    const methodGetCourseWWWInfo = async () => {
        await apiService.asyncApiPost('GetCourseWWWInfo', formDataHeading).then((response) => {
   
            dispatch(setCurseHadings(response.responseBody.body));
            let dataSystem = new Date(response.responseBody.body.startingDate);
            let dataTodey = new Date();
            // if (!response.responseBody.body) {
            //     console.log("www")
            //     history.push('/login_error_key');
            // }
            if (dataSystem > dataTodey) {
                dataSelecrCurse(setStartDate(response.responseBody.body.startingDate));
            } else {
                dataSelecrCurse(setStartDate(formData.startDate));
            }
        });

        return 'Finished methodGetCourseWWWInfo';
    };

    function tegetRelationsUsersst() {
        setallert(true);
        axios
            .get(getSubaccountsURL, config)
            .then((response) => {
                setRes(response.data);
                setGetResponse(response.data.length);
                setTimeout(() => {
                    setallert(false);
                }, 800);
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    history.push('/Error_sesja_wygasla');
                    setallert(false);
                }
            });
    }

    function formatData(data) {
        if (data && data !== null) {
            let newData = data.split(' ');
            let newDatapase = newData[0].split('/');
            return newDatapase[0] + '-' + newDatapase[1] + '-' + newDatapase[2];
        } else {
            return null;
        }
    }

    function calculateAge(dateOfBirdth) {
        let age = 0;
        if (
            dateOfBirdth &&
            dateOfBirdth.toString() !== '' &&
            dateOfBirdth.toString().length === 10
        ) {
            if (new Date(dateOfBirdth) > new Date()) {
                age = 0;
            } else {
                age = -1;
                const dateOfBirdthNew = new Date(dateOfBirdth);
                const timeDiff = Math.abs(Date.now() - dateOfBirdthNew);
                age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365);
            }
        } else {
            age = null;
        }
        return age;
    }

    useEffect(() => {
        axios
            .get(getSubaccountsURL, config)
            .then((response) => {
                setRes(response.data);
                setGetResponse(response.data.length);
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    history.push('/Error_sesja_wygasla');
                }
            });

        apiService.apiGet('UserGet', (response) => {
            if (response.success) {
                usersPayerDispatch(setUsersPayer(response.data));
                localStorage.setItem('users', JSON.stringify(response.data));
                participantActive = response.data.active;
                participantBuilding = response.data.building;
                participantCity = response.data.city;
                participantDateOfBirdth = response.data.dateOfBirdth;
                participantEmail = response.data.email;
                participantFirstName = response.data.firstName;
                participantFlat = response.data.flat;
                participantGenderDVID = response.data.genderDVID;
                participantLastName = response.data.lastName;
                participantLogin = response.data.login;
                participantPersonalDataProcessingConsent =  response.data.personalDataProcessingConsent;
                participantPesel = response.data.pesel;
                participantPhone = response.data.phone;
                participantPostalCode = response.data.postalCode;
                participantStreet = response.data.street;
                participantUsersID = response.data.usersID;
                if (!usersParticipant) {
                    defaultStateUsers = true;
                    localStorage.setItem('usersParticipant', JSON.stringify(''));
                    usersParticipantDispatch(setUsersParticipant(''));
                }
                localStorage.setItem('participantUsersID', participantUsersID);
            } else {
                notificationService.showError();
            }
        });

        methodGetCourseWWWInfo();
    }, []);

    const save = (e) => {
        e.preventDefault();

        if (validate()) {
            history.push('/Wybor_opcji_2_data');
        }
    };

    const validate = () => {
        if (payerUserdata) {
            const profileDataIncomplete = () => {
                notificationService.showError(
                    'Nie uzupełniono wszystkich wymaganych danych użytkownika w profilu. Prosimy o kontakt z BOK'
                );
            };

            if (
                typeof payerUserdata.dateOfBirdth === 'string' &&
                payerUserdata.dateOfBirdth.length > 0
            ) {
                const birthDate = new Date(payerUserdata.dateOfBirdth);
                if (globals.isValidDate(birthDate)) {
                    if (calculateAge(formatData(payerUserdata.dateOfBirdth)) < 18) {
                        notificationService.showError(
                            'Osoba podpisująca umowę musi być pełnoletnia'
                        );
                        return false;
                    }
                } else {
                    profileDataIncomplete();
                    return false;
                }
            } else {
                profileDataIncomplete();
                return false;
            }

            if (!(typeof payerUserdata.pesel === 'string' && payerUserdata.pesel.length === 11)) {
                profileDataIncomplete();
                return false;
            }

            if (
                !(typeof payerUserdata.firstName === 'string' && payerUserdata.firstName.length > 0)
            ) {
                profileDataIncomplete();
                return false;
            }

            if (
                !(typeof payerUserdata.lastName === 'string' && payerUserdata.lastName.length > 0)
            ) {
                profileDataIncomplete();
                return false;
            }

            if (!(typeof payerUserdata.street === 'string' && payerUserdata.street.length > 0)) {
                profileDataIncomplete();
                return false;
            }

            if (
                !(typeof payerUserdata.building === 'string' && payerUserdata.building.length > 0)
            ) {
                profileDataIncomplete();
                return false;
            }

            if (!(typeof payerUserdata.city === 'string' && payerUserdata.city.length > 0)) {
                profileDataIncomplete();
                return false;
            }

            if (!(typeof payerUserdata.email === 'string' && payerUserdata.email.length > 0)) {
                profileDataIncomplete();
                return false;
            }

            if (!(typeof payerUserdata.phone === 'string' && payerUserdata.phone.length > 0)) {
                profileDataIncomplete();
                return false;
            }

            return true;
        } else {
            notificationService.showError();
            return false;
        }
    };

    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">
                        Proces zakupu kursu: {localStorage.getItem('courseHeadingName')}
                    </span>
                </div>
            </header>
            <div className="content">
                <ProfileHeader></ProfileHeader>

                <aside className="registration-steps margin-top-32">
                    <div className="step">
                        <div className="step__circle step__circle--active">
                            <span className="step__count">1</span>
                        </div>
                        <span className="step__text">Wybór&nbsp;kursu</span>
                    </div>
                    <div className="step">
                        <div className="step__circle">
                            <span className="step__count">2</span>
                        </div>
                        <span className="step__text">Umowa</span>
                    </div>
                    <div className="step">
                        <div className="step__circle">
                            <span className="step__count">3</span>
                        </div>
                        <span className="step__text">Płatność</span>
                    </div>
                </aside>
                <aside className="registration-course-steps margin-top-16">
                    <span className="step step--active">Uczestnik</span>
                    <div className="hyphen"></div>
                    <span className="step">Data</span>
                    <div className="hyphen"></div>
                    <span className="step">Wariant</span>
                    <div className="hyphen"></div>
                    <span className="step">Forma płatności i rabat</span>
                    <div className="hyphen"></div>
                    <span className="step">Raty</span>
                </aside>
                <main className="responsive-padding">
                    <section className="course-options-participant margin-top-64">
                        <h2 className="h2">Uczestnik kursu</h2>
                        <form
                            id="course-options-participant-form"
                            className="margin-top-32"
                            method="post"
                            action=""
                            onSubmit={(e) => save(e)}
                        >
                            <fieldset className="margin-top-32">
                                <legend className="h3">Dla kogo kupujesz kurs?</legend>
                                <ul className="participant-list margin-top-16">
                                    <li className="participant">
                                        <input
                                            type="radio"
                                            id="participant-me"
                                            name="participant"
                                            value="Dla siebie"
                                            className="form__radio"
                                            defaultChecked={defaultStateUsers}
                                            onClick={(e) => {
                                                localStorage.setItem(
                                                    'participant',
                                                    participantFirstName + ' ' + participantLastName
                                                );
                                                localStorage.setItem(
                                                    'usersParticipant',
                                                    JSON.stringify('')
                                                );
                                                usersParticipantDispatch(setUsersParticipant(''));
                                                setSelectedItem(1);
                                            }}
                                            required
                                        />
                                        <label
                                            htmlFor="participant-me"
                                            className="form__label--checkbox"
                                        >
                                            Dla siebie
                                        </label>
                                    </li>
                                    <li className="participant faked-participant margin-top-8">
                                        <div className="for-related">
                                            <div className="faked-checkbox">
                                                <div className="faked-checkbox__inside display-none"></div>
                                            </div>
                                            <span className="faked-label">
                                                Dla osoby powiązanej
                                            </span>
                                        </div>
                                        <span
                                            className="no-related"
                                            style={{
                                                display: getResponse === 0 ? 'block' : 'none',
                                            }}
                                        >
                                            Nie masz obecnie żadnych osób powiązanych
                                        </span>
                                    </li>
                                    <ul id="related-list">
                                        {res.map((el) => (
                                            // usersParticipantSelect = el,

                                            <RelatedPerson
                                                selectedItem={selectedItem}
                                                key={el.usersID}
                                                setSelectedItem={setSelectedItem}
                                                active={el.status}
                                                building={el.building}
                                                city={el.city}
                                                dateFrom={el.dateFrom}
                                                dateOfBirdth={el.dateOfBirdth}
                                                dateTo={el.dateTo}
                                                description={el.description}
                                                email={el.email}
                                                firstName={el.firstName}
                                                flat={el.flat}
                                                genderDVID={el.genderDVID}
                                                lastName={el.lastName}
                                                login={el.login}
                                                participantRelationsDVID={
                                                    el.participantRelationsDVID
                                                }
                                                personalDataProcessingConsent={
                                                    el.personalDataProcessingConsent
                                                }
                                                pesel={el.pesel}
                                                phone={el.phone}
                                                postalCode={el.postalCode}
                                                street={el.street}
                                                usersID={el.usersID}
                                                selectUsers={el}
                                                usersParticipant={usersParticipant}
                                                onPaymentDataChange={() => {
                                                    tegetRelationsUsersst();
                                                }}
                                            />
                                        ))}
                                    </ul>
                                </ul>
                            </fieldset>
                            <div>{allert ? <p>Odświeżam powiązanie</p> : ''}</div>
                            <div>
                                <Link to="/osoba_powiazana_dodaj">
                                    <a
                                        href=""
                                        className="btn-secondary-responsive btn-secondary-responsive--small margin-top-32"
                                    >
                                        Dodaj osobę powiązaną
                                    </a>
                                </Link>
                            </div>
                          
                            <button type="button" className="about-related__btn margin-top-16">
                                Kto to jest osoba powiązana?
                                <svg
                                    className="about-related__chevron"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6 9L12 15L18 9"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>
                            <div className="about-related opacity-0 max-height-0">
                                <p>Osoba powiązana to ...</p>
                                <p>
                                    Osobę powiązaną możesz w każdej chwili dodać także z poziomu
                                    swojego profilu.
                                </p>
                            </div>
                            <input
                                type="submit"
                                disabled={
                                    false
                                    /* users ? calculateAge(formatData(users.dateOfBirdth)) < 18 : true */
                                }
                                value="Dalej"
                                className={`btn-primary margin-top-64 margin-bottom-32 
                                ${
                                    ''
                                    /* (
                                        users
                                            ? calculateAge(formatData(users.dateOfBirdth)) < 18
                                            : true
                                    )
                                        ? 'button-disabled'
                                        : '' */
                                }
                                `}
                            />
                            {/* <div>
                                {(
                                    users ? calculateAge(formatData(users.dateOfBirdth)) < 18 : true
                                ) ? (
                                    <p className="message">
                                        Osoba podpisująca umowę musi być pełnoletnia
                                    </p>
                                ) : (
                                    ''
                                )}
                            </div> */}
                        </form>
                    </section>
                </main>
            </div>

            <EDSFooter></EDSFooter>
        </>
    );
};
export default Wybor_opcji_1_uczestnik;
